import React from 'react';
import './ContactStats.css';

const ContactStats = () => {
    return (
        <>
            {/* ==================== SECTION 1: PREMIUM CALL TO ACTION ==================== */}
            <section id="call-to-action-v3" className="cta-modern-section-v3 py-5">
                <div className="container">
                    <div className="row m-0">
                        <div className="col-xl-10 mx-auto">
                            <div className="cta-glass-card-v3">
                                <div className="glow-orb-v3 position-1"></div>
                                <div className="glow-orb-v3 position-2"></div>
                                
                                <div className="row align-items-center gy-4 position-relative" style={{ zIndex: 2 }}>
                                    <div className="col-lg-8 text-center text-lg-start">
                                        <div className="badge-pill-v3 mb-3">
                                            <span className="badge-pulse-v3"></span>
                                            <span className="badge-text-v3">24/7 Enterprise Support</span>
                                        </div>
                                        <h3 className="cta-title-v3 mb-3">
                                            Let’s Connect & Grow <span className="text-gradient-v3">Together</span>
                                        </h3>
                                        <p className="cta-text-v3 mb-0">
                                            Whether you have a critical query, feedback, or strategic integration ideas, our core infrastructure engineering and support teams are live and ready to route your calls instantly.
                                        </p>
                                    </div>
                                    <div className="col-lg-4 text-center text-lg-end">
                                        <a className="btn-cta-premium-v3" href="tel:0120-4151488">
                                            <div className="btn-icon-v3">
                                                <i className="icofont-phone"></i>
                                            </div>
                                            <div className="btn-label-v3">
                                                <span>Call Now</span>
                                                <small>0120-4151488</small>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==================== SECTION 2: HIGH-METRIC IMPRESSIVE COUNTERS ==================== */}
            <section id="why-us-v3" className="metrics-modern-section-v3 py-5 mb-5">
                <div className="container">
                    <div className="row g-4 justify-content-center">
                        
                        {/* Metric Node 1 */}
                        <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="100">
                            <div className="metric-card-v3 border-top-gradient-blue">
                                <div className="metric-icon-box-v3 bg-soft-blue">
                                    <i className="icofont-pie-chart"></i>
                                </div>
                                <div className="metric-data-v3">
                                    <h2 className="counter-number-v3">50<span className="counter-plus-v3">+</span></h2>
                                    <p className="counter-label-v3">Products & Services</p>
                                </div>
                                <div className="metric-progress-line-v3 bg-blue"></div>
                            </div>
                        </div>

                        {/* Metric Node 2 */}
                        <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="200">
                            <div className="metric-card-v3 border-top-gradient-indigo">
                                <div className="metric-icon-box-v3 bg-soft-indigo">
                                    <i className="icofont-users-social"></i>
                                </div>
                                <div className="metric-data-v3">
                                    <h2 className="counter-number-v3">500<span className="counter-plus-v3">+</span></h2>
                                    <p className="counter-label-v3">Associated Distributors</p>
                                </div>
                                <div className="metric-progress-line-v3 bg-indigo"></div>
                            </div>
                        </div>

                        {/* Metric Node 3 */}
                        <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="300">
                            <div className="metric-card-v3 border-top-gradient-emerald">
                                <div className="metric-icon-box-v3 bg-soft-emerald">
                                    <i className="icofont-users"></i>
                                </div>
                                <div className="metric-data-v3">
                                    <h2 className="counter-number-v3">20<span className="counter-plus-v3">K</span></h2>
                                    <p className="counter-label-v3">Active Retailers</p>
                                </div>
                                <div className="metric-progress-line-v3 bg-emerald"></div>
                            </div>
                        </div>

                        {/* Metric Node 4 */}
                        <div className="col-lg-3 col-sm-6" data-aos="fade-up" data-aos-delay="400">
                            <div className="metric-card-v3 border-top-gradient-amber">
                                <div className="metric-icon-box-v3 bg-soft-amber">
                                    <i className="icofont-fast-delivery"></i>
                                </div>
                                <div className="metric-data-v3">
                                    <h2 className="counter-number-v3">150<span className="counter-plus-v3">K</span></h2>
                                    <p className="counter-label-v3">Transactions / Day</p>
                                </div>
                                <div className="metric-progress-line-v3 bg-amber"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactStats;